import React from "react";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useTranslations } from '../../../locales/useTranslations';

const PowerBiVerständnisundErfahrungfürIhreBranche = () => {
    const { t } = useTranslations();
    return (
        <section className="ptb-100 powerbi-experience">
            {/* Dekorative Hintergrund-Elemente */}
            <div className="powerbi-experience__decoration powerbi-experience__decoration--top-right"></div>
            <div className="powerbi-experience__decoration powerbi-experience__decoration--bottom-left"></div>

            <div className="container pb-35 powerbi-experience__container">
                <div className="about-content text-center">
                    <span className="powerbi-experience__badge">
                        {t('powerBi_verständnisundErfahrungfürIhreBranche_title')}
                    </span>
                    <h2 className="powerbi-experience__title">
                        {t('powerBi_verständnisundErfahrungfürIhreBranche_title2')}
                    </h2>
                    <p className="powerbi-experience__description">
                        {t('powerBi_verständnisundErfahrungfürIhreBranche_description')}
                    </p>
                </div>
            </div>

            <div className="overview-item powerbi-experience__container">
                <div className="container max-width-600">
                    <div className="native-accordion powerbi-experience__accordion">
                        <details>
                            <summary>
                                {t('powerBi_verständnisundErfahrungfürIhreBranche_title3')}
                            </summary>
                            <div className="powerbi-experience__answer-container">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <p className="powerbi-experience__answer-text">
                                                {t('powerBi_verständnisundErfahrungfürIhreBranche_description3')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>

                        <details>
                            <summary>
                                {t('powerBi_verständnisundErfahrungfürIhreBranche_title4')}
                            </summary>
                            <div className="powerbi-experience__answer-container">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <p className="powerbi-experience__answer-text">
                                                {t('powerBi_verständnisundErfahrungfürIhreBranche_description4')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>

                        <details>
                            <summary>
                                {t('powerBi_verständnisundErfahrungfürIhreBranche_title5')}
                            </summary>
                            <div className="powerbi-experience__answer-container">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <p className="powerbi-experience__answer-text">
                                                {t('powerBi_verständnisundErfahrungfürIhreBranche_description5')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>

                        <details>
                            <summary>
                                {t('powerBi_verständnisundErfahrungfürIhreBranche_title6')}
                            </summary>
                            <div className="powerbi-experience__answer-container">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <p className="powerbi-experience__answer-text">
                                                {t('powerBi_verständnisundErfahrungfürIhreBranche_description6')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>

                        <details>
                            <summary>
                                {t('powerBi_verständnisundErfahrungfürIhreBranche_title7')}
                            </summary>
                            <div className="powerbi-experience__answer-container">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <p className="powerbi-experience__answer-text">
                                                {t('powerBi_verständnisundErfahrungfürIhreBranche_description7')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </details>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PowerBiVerständnisundErfahrungfürIhreBranche;
